import 'es6-promise/auto' // Required for IE to even load the website!
import 'es6-object-assign/auto' // Required for IE to even load the website!
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Security from './components/mixins/SecurityMixin'

// See https://github.com/dkfbasel/vuex-i18n for usage
import vuexI18n from 'vuex-i18n'
import * as en from './lang/en.json'
import * as es from './lang/es.json'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faQuoteLeft,
  faQuoteRight,
  faShare,
  faExclamationTriangle,
  faPlay,
  faFilePdf,
  faEnvelope,
  faKey,
  faFileAudio
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Load the stuff we need from Firebase
// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app'
// Add the Firebase products that you want to use
import 'firebase/auth'

// Import Google Tag Manager
import VueGtm from 'vue-gtm'

// We have to include the bmg.scss file here because otherwise it doesn't get
//  bundled properly with the other css and Firebase Hosting serves it up as HTML
//  instead of css!
import './scss/bmg.scss'

// Make the firebase objects available in the component created() area
// See https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins/ for details
Object.defineProperty(Vue.prototype, '$firebase', { value: firebase })
// Object.defineProperty(Vue.prototype, '$firebaseui', { value: firebaseui })

library.add(
  faQuoteLeft,
  faQuoteRight,
  faShare,
  faExclamationTriangle,
  faPlay,
  faFilePdf,
  faEnvelope,
  faKey,
  faFileAudio
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(vuexI18n.plugin, store)

Vue.config.productionTip = false

// add translations directly to the application
// Vue.i18n.add('en', en)
// Vue.i18n.add('es', es)

// set the start locale to use
// Vue.i18n.set('es')

// Set up Google Tag Manager
Vue.use(VueGtm, {
  id: 'GTM-WC2RSRG', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview:'env-4',
  //   gtm_cookies_win:'x'
  // },
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})

// Define whether security is enabled. If enabled then the
store.commit('setUseSecurity', false)

new Vue({
  el: '#app',
  store,
  router: router,
  mixins: [Security],
  render: h => h(App),
  // template: '<App/>',
  // components: {
  //   App
  // },
  // These are all the lifecycle hooks available in Vue
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    // console.log('Logging out...')
    // this.$root.logOut()
    // .then(function () {
    //   console.log('Signed out of Firebase')
    // })
  },
  destroyed() {}
}).$mount('#app')
